export const OPTIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
};

export const TEMPLATE_NAME_MAX_LENGTH = 80;
export const DESCRIPTION_MAX_LENGTH = 150;
